export enum WORKING_RIGHTS_OPTIONS {
    australian_citizen = 'Yes, I am an Australian Citizen',
    new_zealand_citizen = 'Yes, I am a New Zealand Citizen',
    australian_permanent_resident = 'Yes, I am an Australian Permanent Resident',
    australian_visa_holder = 'Yes, I am an Australian Work Visa holder',
    dont_have_australia_working_rights = 'No, I do not have current working rights in Australia'
}

export enum EARLY_CHILDHOOD_EDUCATION {
    POST_GRADUATE_DIPLOMA = 'Post Graduate Diploma',
    BACHELOR_OR_DEGREE = 'Bachelor or Degree',
    DIPLOMA = 'Diploma',
    CERTIFICATE_III = 'Certificate III',
    I_AM_CURRENTLY_STUDYING = 'I am currently completing my studies in Early Childhood Education',
    I_HAVE_NO_QUALIFICATION = 'I have no qualifications in Early Childhood Education'
}

export enum COMPLETE_YOUR_STUDIES {
    AUSTRALIA = 'Australia',
    NEW_ZEALAND = 'New Zealand',
    OTHER = 'Other'
}

export enum ALTERNATIVE_POSITIONS {
    ADMIN_ASSISTANT = 'Admin Assistant',
    CLEANER = 'Cleaner',
    GARDENER = 'Gardener',
    CHEF_COOK = 'Chef/Cook'
}

export enum MODE_OF_TRANSPORT {
    CAR = 'Car',
    BUS = 'Bus',
    TRAIN = 'Train',
    TRAM = 'Tram'
}

export type Days = 
    | "Everyday"
    | "Monday"
    | "Tuesday"
    | "Wednesday"
    | "Thursday"
    | "Friday"
    | "Saturday"
    | "Sunday";

export enum OTHER_QUALIFICATIONS_LEVEL {
    BACHELOR_OR_DEGREE = 'Bachelor or Degree',
    DIPLOMA = 'Diploma',
    CERTIFICATE_III = 'Certificate III',
}